<template>
  <v-container>
    <c-card class="white">
      <div style="font-size: 18px" class="black--text font-weight-bold">최근 점검일/교체일</div>
      <v-row class="mx-6 mt-3">
        <v-col cols="3">정기점검일</v-col>
        <v-col cols="3"> {{ setData(recentList.regularInspection)}}</v-col>
        <v-col cols="6"></v-col>
        <v-col cols="3">엔진 오일</v-col>
        <v-col cols="3"> {{ setData(recentList.engineOil)}}</v-col>
        <v-col cols="3">와이퍼</v-col>
        <v-col cols="3"> {{ setData(recentList.wiper)}}</v-col>
        <v-col cols="3">에어컨 필터</v-col>
        <v-col cols="3"> {{ setData(recentList.acFilter)}}</v-col>
        <v-col cols="3">휠 얼라이먼트</v-col>
        <v-col cols="3"> {{ setData(recentList.wheelAlignment)}}</v-col>
        <v-col cols="3">전륜 타이어</v-col>
        <v-col cols="3"> {{ setData(recentList.frontTier)}}</v-col>
        <v-col cols="3">후륜 타이어</v-col>
        <v-col cols="3"> {{ setData(recentList.rearTier)}}</v-col>
        <v-col cols="3">배터리</v-col>
        <v-col cols="3"> {{ setData(recentList.battery) }}</v-col>
        <v-col cols="3">브레이크 패드/라이닝</v-col>
        <v-col cols="3"> {{ setData(recentList.breakPad)}}</v-col>
        <v-col cols="3">미션 오일</v-col>
        <v-col cols="3"> {{ setData(recentList.missionOil)}}</v-col>
        <v-col cols="3">브레이크 오일</v-col>
        <v-col cols="3"> {{ setData(recentList.breakOil)}}</v-col>
        <v-col cols="3">냉각수</v-col>
        <v-col cols="3"> {{ setData(recentList.coolant)}}</v-col>
        <v-col cols="3">등화장치</v-col>
        <v-col cols="3"> {{ setData(recentList.beam)}}</v-col>
      </v-row>
      <v-divider class="my-10"></v-divider>
      <div style="font-size: 18px" class="black--text font-weight-bold">정비 내역</div>
      <v-row class="pl-2" align="center">
        <v-col cols="10" class="pl-2">
          <v-row align="center">
            <v-menu
              v-model="notBeforeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div style="width: 200px">
                  <v-text-field
                    v-model="notBefore"
                    label="시작일"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker v-model="notBefore" @input="notBeforeMenu = false" firstDayOfWeek="1" :selectedDate="notBefore" locale="ko-kr"></c-date-picker>
            </v-menu>
            <v-menu
              v-model="notAfterMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div class="ml-5" style="width: 200px">
                  <v-text-field
                    v-model="notAfter"
                    label="종료일"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker v-model="notAfter" @input="notAfterMenu = false" firstDayOfWeek="1" :selectedDate="notAfter" locale="ko-kr"></c-date-picker>
            </v-menu>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <c-btn color="blue" outlined iconName="add" @click="dataAddDialog = true">내역추가</c-btn>
        </v-col>
      </v-row>
      <c-table :headers="tableHeaders" :items="tableItems">
        <template #date="{item}">
          {{item.date}} {{item.time}}
        </template>
        <template #actor="{item}">
          {{item.type === 'admin' ? item.admin.name : item.driver.name}}
        </template>
        <template #list="{item}">
          <div @click="onShowListDetails(item)">
            <v-chip small class="ma-1" v-if="item.maintenanceList.length>0"> 정비 : {{majorList(item.maintenanceList)}}</v-chip>
            <v-chip small class="ma-1" v-if="item.changeList.length>0"> 교체 : {{majorList(item.changeList)}}</v-chip>
          </div>
        </template>
        <template #price="{item}">
          {{Number(item.price).toLocaleString()}}
        </template>
        <template #etc="{item}">
          <c-btn icon iconName="mdi-pencil" @click="onUpdateListItem(item)"></c-btn>
          <c-btn icon iconName="delete" @click="reqDeleteListItem(item.id)"></c-btn>
        </template>
      </c-table>
    </c-card>
    <maintenance-c-u-dialog
      :open.sync="dataAddDialog"
      :defaultInfo.sync="defaultInfo"
      :driverList="driverList"
      :adminList="adminList"
      @reqAddMaintenance="reqAddMaintenance"
      @reqUpdateMaintenance="reqUpdateMaintenance"
    ></maintenance-c-u-dialog>

    <v-dialog v-model="listDetailDialog" width="500" hide-overlay>
      <c-card
        class="white"
        title="주요 정비 내역"
      >
        <v-row>
          <v-col cols="3">점검 내역</v-col>
          <v-col cols="9">{{this.selectedRow.maintenanceList ? this.selectedRow.maintenanceList : '-'}}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">교체 내역</v-col>
          <v-col cols="9">{{this.selectedRow.changeList ? this.selectedRow.changeList : '-'}}</v-col>
        </v-row>
        <div class="py-6">
        </div>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import MaintenanceCUDialog from './MaintenanceCUDialog'

  export default {
    components: {MaintenanceCUDialog},
    data() {
      return {
        notBeforeMenu: false,
        notAfterMenu: false,
        notBefore: this.$func.curDateStringAddDays(-30),
        notAfter : this.$func.curDateString(),
        dataAddDialog: false,
        tableHeaders: [
          {
            text:'일시',
            sortable: true,
            align:'center',
            value:'date'
          },
          {
            text:'담당자',
            sortable: true,
            align:'center',
            value:'actor'
          },
          {
            text:'정비처',
            sortable: true,
            align:'center',
            value:'location'
          },
          {
            text:'금액 (원)',
            sortable: true,
            align:'center',
            value:'price'
          },
          {
            text:'주요 정비 내역',
            sortable: true,
            align:'center',
            value:'list'
          },
          {
            text:'',
            sortable: true,
            align:'center',
            value:'etc'
          },
        ],
        tableItems: [],
        adminList: [],
        driverList: [],
        recentList:{},
        defaultInfo: {},
        listDetailDialog:false,
        selectedRow : {},
      }
    },
    mounted() {
      this.getMaintenanceList();
      this.getMaintenanceListItem();
      this.reqAdminList();
      this.reqDriverList();
    },

    watch: {
      notBefore: function () {
        this.getMaintenanceList();
      },
      notAfter: function () {
        this.getMaintenanceList();
      }
    },
    methods : {
      setData(data){
        return data !=null ? data : '-';
      },
      async getMaintenanceListItem() {
        const res = await this.$api.getMaintenanceListItem(this.$route.params.vehicleId);
        this.recentList = res.data;
      },
      async getMaintenanceList() {
        const res = await this.$api.getMaintenanceList(this.$route.params.vehicleId, this.notBefore, this.notAfter);
        this.tableItems = res.data;
      },
      async reqAdminList() {
        const res = await this.$api.getAdminListByRole(this.$store.state.service);
        this.adminList = res.data;
      },
      async reqDriverList() {
        const res = await this.$api.getVehicleAllDriver(this.$route.params.vehicleId);
        this.driverList = res.data;
      },
      async reqAddMaintenance(data) {
        let changeItemTextList = [];
        let changeItemValueList = [];
        let itemValueList = [];
        let maintenanceItemTextList = [];
        let maintenanceItemValueList = [];
        for(let idx in data.changeList) {
          changeItemTextList.push(data.changeList[idx].text);
          changeItemValueList.push(data.changeList[idx].value);
          itemValueList.push(data.changeList[idx].value);
        }

        for(let idx in data.maintenanceList) {
          maintenanceItemTextList.push(data.maintenanceList[idx].text);
          maintenanceItemValueList.push(data.maintenanceList[idx].value);
          itemValueList.push(data.maintenanceList[idx].value);
        }

        data['vehicleId'] = this.$route.params.vehicleId;
        data['changeItemTextList'] = changeItemTextList.join();
        data['changeItemValueList'] = changeItemValueList;
        data['maintenanceItemTextList'] = maintenanceItemTextList.join();
        data['maintenanceItemValueList'] = maintenanceItemValueList;
        data['itemValueList'] = itemValueList.join();
        data.typeValue = JSON.stringify(data.typeValue);

        const res = await this.$api.addMaintenance(data);
        this.$store.commit('snackbar', {color: 'blue', msg: '정비 정보가 추가되었습니다.'});
        this.getMaintenanceList();
        this.getMaintenanceListItem();
      },
      async reqUpdateMaintenance(data) {

        let changeItemTextList = [];
        let changeItemValueList = [];
        let itemValueList = [];
        let maintenanceItemTextList = [];
        let maintenanceItemValueList = [];

        for(let idx in data.changeList) {
          changeItemTextList.push(data.changeList[idx].text);
          changeItemValueList.push(data.changeList[idx].value);
          itemValueList.push(data.changeList[idx].value);
        }

        for(let idx in data.maintenanceList) {
          maintenanceItemTextList.push(data.maintenanceList[idx].text);
          maintenanceItemValueList.push(data.maintenanceList[idx].value);
          itemValueList.push(data.maintenanceList[idx].value);
        }

        data['vehicleId'] = this.$route.params.vehicleId;
        data['changeItemTextList'] = changeItemTextList.join();
        data['changeItemValueList'] = changeItemValueList;
        data['maintenanceItemTextList'] = maintenanceItemTextList.join();
        data['maintenanceItemValueList'] = maintenanceItemValueList;
        data['itemValueList'] = itemValueList.join();
        data.typeValue = JSON.stringify(data.typeValue);

        const res = await this.$api.updateMaintenance(data);
        this.$store.commit('snackbar', {color: 'blue', msg: '정비 정보가 수정되었습니다.'});
        this.getMaintenanceList();
        this.getMaintenanceListItem();
      },
      async reqDeleteListItem(id) {
        const res = await this.$api.deleteMaintenance(id);
        this.$store.commit('snackbar', {color: 'blue', msg: '정비 정보가 삭제되었습니다.'});
        this.getMaintenanceList();
        this.getMaintenanceListItem();
      },
      onUpdateListItem(item) {
        this.defaultInfo = {...item};
        this.dataAddDialog = true;
      },
      majorList(data){
        let len = data.split(',').length;
        if(len < 3) return data;
        else {
          let str = [];
          for(let idx in data.split(',')) {
            if(idx < 2) str.push(data.split(',')[idx]);
            else break;
          }
          return str.join()
        }
      },
      onShowListDetails(item) {
        this.selectedRow = item;
        this.listDetailDialog=true;
      }
    }
  }
</script>

<style scoped>

</style>